import styled from 'styled-components';

export const NawWrapper = styled.div`
  display: flex;
  justify-content: center;
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 11;
  box-shadow: 0px 4px 8px 0px rgba(60, 60, 59, 0.04);
`;

export const SplitRow = styled.div`
  display: flex;
  justify-content: space-between;
  & nav {
    margin: 0;
  }
`;
